import Banner from '@components/Banner';
import { ButtonPrimary } from '@components/Button';
import CardService from '@components/CardService';
import HeadSEO from '@components/HeadSEO';
import { dataAdvisory, dataHireDevelopers, menuServiceData } from '@components/pages/services/data';
import { Col, Image, Row } from 'antd';
import { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Link from 'next/link';
import { Element, scroller } from 'react-scroll';

const Services = () => {
  const { t } = useTranslation();

  const itemBreadcrumbs = [
    {
      name: t('common.home'),
      path: '/',
    },
    {
      name: t('common.services'),
      path: '/services',
    },
  ];
  const handleScroll = (id) => () => {
    scroller.scrollTo(id, {
      duration: 1500,
      delay: 100,
      smooth: true,
      offset: -150,
    });
  };

  return (
    <div className="services">
      <HeadSEO
        title={t('head-seo.titleService')}
        description={t('head-seo.metaService')}
        keywords={t('head-seo.keywordService')}
        image="/images/preview/our-service.jpg"
      />

      <Banner
        title={t('home.our_services_offerings')}
        description={t('service.whether_youre_a_newfound_startup')}
        itemBreadcrumbs={itemBreadcrumbs}
        childComponent={
          <Link href="/contact">
            <ButtonPrimary onClick={handleScroll('contact-us-form')}>{t('service.buttonTalkToUs')}</ButtonPrimary>
          </Link>
        }
      />
      <div className="container">
        {menuServiceData(t).map((service, index) => (
          <Element name={service.id} key={index} className={service.id}>
            <CardService {...service} />
          </Element>
        ))}

        <Row className="card-second-layout">
          <Col sm={24} xl={12}>
            <Element name={dataAdvisory(t).id} key={dataAdvisory(t).id}>
              <CardService {...dataAdvisory(t)} />
            </Element>
          </Col>

          <Col sm={24} xl={12}>
            <Element
              key={dataHireDevelopers(t).id}
              name={dataHireDevelopers(t).id}
              className={dataHireDevelopers(t).id}
            >
              <CardService {...dataHireDevelopers(t)} />
            </Element>
          </Col>
        </Row>
      </div>
      {/* <div className="container">
        <Row className="card-second-layout">
          <Col sm={24} xl={12}>
            <Image></Image>p
          </Col>

          <Col sm={24} xl={12}></Col>
        </Row>
      </div> */}
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ locale }: any) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

export default Services;
